import React, { useState } from 'react';
import InputTypeSwitch from './InputTypeSwitch';
import DropdownButton from '../../buttons/DropdownButtonComponent';
import classNames from '../../../utility/classNames';

export default function TableSection({ label, schema, externalData = {} }) {
  const [open, setOpen] = useState(false);
  //for this element we want to use the label as the text for the dropdown button
  const text = {
    isOpen: label,
    isClosed: label,
  };

  return (
    <div
      className={classNames('flex justify-between flex-col lg:min-w-[360px]')}
    >
      <DropdownButton
        isOpen={open}
        setOpen={() => setOpen(!open)}
        text={text}
        textStyles="text-md font-normal text-neutral-900 inline"
        buttonStyles={classNames('-ml-2', open && 'mb-2')}
        mobileTextVis="inline"
      />

      {/* <h4 className="text-primary text-md">{label}</h4> */}
      {schema && (
        <div
          className={classNames(
            !open && 'hidden',
            'p-2 -ml-1  rounded-lg lg:min-h-[360px] border border-neutral-50'
          )}
        >
          {schema.map((field, ind) => (
            <div key={field.name} className="m-2 my-4">
              <InputTypeSwitch
                elem={{ ...field, preValue: externalData[field.name] }}
                index={ind}
                externalData={externalData}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
